import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {BusStation} from '../../../services/models/BusStation';
import {CityStore, City} from '../../../services/stores/city.store';
import {CatalogService} from '../../../services/catalog-service';
import {SharedModule} from '../../../components/shared.module';
import {InputComponent} from '../../../components/input/input.component';
import {AnkataSelectComponent} from '../../../components/ankata-select/ankata-select.component';

@Component({
	selector: 'app-edit-bus-station-modal',
  imports: [
    ...SharedModule,
    InputComponent,
    AnkataSelectComponent
  ],
	templateUrl: './edit-bus-station-modal.component.html',
	styleUrls: ['./edit-bus-station-modal.component.scss']
})
export class EditBusStationModalComponent implements OnInit {

	form: FormGroup;
	busStation?: BusStation;
	editMode: boolean;
	cities: City[];
	constructor(
		private fb: FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<EditBusStationModalComponent>,
    private _cityStoreService: CityStore,
    private _catalogService: CatalogService,
	) {
		this.form = new FormGroup({});
		if (data && data.busStation) {
			this.busStation = data.busStation;
			this.editMode = true;
		}
		this.buildForm(this.busStation);
	}

	ngOnInit() {
    this.cities = this._cityStoreService.items
	}


	buildForm(busStation?: BusStation) {
		this.form = this.fb.group({
			'cityId': ['', [Validators.required]],
			'name': ['', [Validators.required]]
		});
		if (this.editMode && busStation) {
			Object.keys(busStation).forEach(key => {
				if (this.form.contains(key)) {
					// @ts-ignore
          this.form.controls[key].setValue(busStation[key]);
				}
			});
		}
	}

	edit() {
		if (this.form.valid) {
			if (this.editMode) {
				this._catalogService.editBusStation(this.busStation!.id, this.form.getRawValue() as BusStation).subscribe(data => {
					// this.toastService.success('La gare a bien été modifiée.');
					this.dialogRef.close(data);
				});
			}	else {
				this._catalogService.addBusStation(this.form.getRawValue() as BusStation).subscribe(data => {
					// this.toastService.success('La gare a bien été créée.');
					this.dialogRef.close(data);
				});
			}
		}

	}
}
